import parse from 'html-react-parser';
import type React from 'react';
import DOMService from '../../../services/DOMService';
import type { TextData } from '../../../types/ChatWindow';
import { parseMessageProtocols } from '../messageHelper';

type IProps = { data: TextData };

const TextMessage: React.FC<IProps> = ({ data }) => {
  const { text } = data;
  const purifiedText = DOMService.purify(text);
  const messageDisplay = parseMessageProtocols(purifiedText);
  const parsedText = parse(messageDisplay);

  return <div className='word-break-style'>{parsedText}</div>;
};

export default TextMessage;
